import { Component, Inject } from "@angular/core"
import { CommonModule } from "@angular/common"
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog"
import { MatIconModule } from "@angular/material/icon"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
import { RatingsService } from "../../../services/ratings.service"
import { SnackbarService } from "../../../services/snackbar.service"
import { Station } from "../../../models/station.model"

export interface FileUploadDialogData {
  station: Station
}

@Component({
  selector: "app-file-upload-dialog",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: "./file-upload-dialog.component.html",
  styleUrls: ["./file-upload-dialog.component.css"],
})
export class FileUploadDialogComponent {
  selectedFile: File | null = null
  fileType: "MF" | "SS" = "MF"
  uploading = false
  dragOver = false

  constructor(
    private dialogRef: MatDialogRef<FileUploadDialogComponent>,
    private ratingsService: RatingsService,
    private snackbar: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: FileUploadDialogData,
  ) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    const file = input.files?.[0]
    if (!file) return
    this.applyFile(file)
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault()
    event.stopPropagation()
    this.dragOver = true
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault()
    event.stopPropagation()
    this.dragOver = false
  }

  onDrop(event: DragEvent): void {
    event.preventDefault()
    event.stopPropagation()
    this.dragOver = false
    const file = event.dataTransfer?.files?.[0]
    if (file) this.applyFile(file)
  }

  clearFile(input: HTMLInputElement): void {
    this.selectedFile = null
    input.value = ""
  }

  formatFileSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`
    return `${(bytes / 1024).toFixed(1)} KB`
  }

  onUpload(): void {
    if (!this.selectedFile) return

    this.uploading = true
    this.ratingsService.uploadTapscanFile(this.data.station.id, this.selectedFile, this.fileType).subscribe({
      next: (response) => {
        this.uploading = false
        this.dialogRef.close(response)
      },
      error: (error) => {
        this.uploading = false
        console.error("Upload error:", error)
        this.snackbar.error(
          "Error uploading file: " + (error.error?.error || error.message || "Unknown error"),
        )
      },
    })
  }

  onCancel(): void {
    this.dialogRef.close()
  }

  private applyFile(file: File): void {
    const allowedTypes = ["text/csv", "application/vnd.ms-excel", "application/csv", "text/plain"]

    if (allowedTypes.includes(file.type) || file.name.toLowerCase().endsWith(".csv")) {
      this.selectedFile = file
    } else {
      this.snackbar.warning("Please select a valid CSV file.")
    }
  }
}
